import type { ColorKey, BrandKey } from '@jotta/design-system/system'
import { designSystem } from '@jotta/design-system/system'
import moize from 'moize'
import { pick, values } from 'remeda'
import { useThemeContext } from '../Brand/ThemeProvider/ThemeProvider'

/**
 * Get selected design system colors for the current brand
 * Memoized for stable object references
 */
export const selectDesignSystemColors = moize(
  <T extends ColorKey>(brand: BrandKey, ...colorKeys: T[]) => {
    const all = designSystem.brands[brand].colors
    const colorMap = pick(all, colorKeys)
    const colors = values(colorMap)
    const data = {
      colors: colors,
      colorMap,
    } as const
    return data
  },
  {
    maxSize: 100,
  },
)
